import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import CampaignsList from "@/pages/CampaignsList";
import CampaignDetail from "@/pages/CampaignDetail";
import Payments from "@/pages/Payments";
import Users from "@/pages/Users";
import AuditLog from "@/pages/AuditLog";
import Accounting from "@/pages/Accounting";
import Approvals from "@/pages/Approvals";
import AppLayout from "@/components/AppLayout";
import { InvoiceViewerProvider } from "@/components/InvoiceViewer";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="text-slate-500 text-sm">Loading…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <InvoiceViewerProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route
              path="/"
              element={
                <Protected>
                  <AppLayout />
                </Protected>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="campaigns" element={<CampaignsList />} />
              <Route path="campaigns/:cid" element={<CampaignDetail />} />
              <Route path="payments" element={<Payments />} />
              <Route path="approvals" element={<Approvals />} />
              <Route path="users" element={<Users />} />
              <Route path="audit-log" element={<AuditLog />} />
              <Route path="accounting" element={<Accounting />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        </InvoiceViewerProvider>
      </AuthProvider>
    </div>
  );
}
